import Croc from './Croc.png';
import Croc2 from './Croc2.png';
import Croc3 from './Croc3.png';
import Croc4 from './Croc4.png';
import Croc5 from './Croc5.png';
import Croc6 from './Croc6.png';
import Group60 from './Group60.png';

export const crocsArr = [Croc, Croc2, Croc3, Croc4, Croc5, Croc6, Group60];